var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99033 3.87205C2.30665 3.3483 4.0495 1.44328 5.29322 1.50079C5.665 1.5316 5.99364 1.7565 6.26067 2.01735C6.87379 2.61607 8.62897 4.88053 8.72859 5.35704C8.97096 6.52572 7.57833 7.19941 8.00454 8.37734C9.09112 11.0362 10.9634 12.9083 13.6233 13.9938C14.8003 14.42 15.474 13.0274 16.6428 13.2708C17.1183 13.3704 19.3839 15.1255 19.9826 15.7386C20.2425 16.0046 20.4684 16.3343 20.4992 16.706C20.5454 18.0154 18.5222 19.7828 18.1278 20.0087C17.1974 20.6742 15.9834 20.6629 14.5035 19.9748C10.3739 18.2567 3.77426 11.7817 2.02422 7.4962C1.35461 6.02456 1.30839 4.80248 1.99033 3.87205Z",
    stroke: "#2F4858",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.50300eca.svg";
export { ForwardRef as ReactComponent };